import React from 'react'

import { getActivitySlugById, sortActivities } from '@/modules/Activities'

import { useFacilitiesMeta } from './useFacilitiesMeta'

/**
 * Use all available activities for search
 */
export const useAvailableActivities = () => {
  const { data } = useFacilitiesMeta()

  return React.useMemo(
    () =>
      sortActivities([...(data?.activities ?? [])]).map((activity) => ({
        id: activity.id,
        name: activity.name,
        slug: getActivitySlugById(activity.id),
      })),
    [data?.activities],
  )
}
